<template>
  	<div class="stores">
    	<div class="breadcrumb">用户管理 > 充值亿米</div>
    	<div class="searchBtn" style="border:none;display:flex">
	      	<el-button size='small' type="primary" @click="add" plain>充值亿米</el-button>
	      	<div class="topinput">
				<input type="text" placeholder="请输入手机号" class="el-input__inner" v-model="mobile" @keyup.enter="search_mine()"/>
			</div>
			<el-button type="primary" @click="search_mine()" style="margin-left:15px">搜索</el-button>
    	</div>
    	<div class="main">
	      	<template>
	        	<el-table
	          		ref="multipleTable"
	          		:data="tableData"
	          		highlight-current-row
	          		tooltip-effect="dark"
	          		style="width: 100%">
		          	<el-table-column prop="mobile"  label="手机号" show-overflow-tooltip></el-table-column>
		          	<el-table-column prop="points" label="亿米数" show-overflow-tooltip></el-table-column>
		          	<el-table-column
			            prop="createTime"
			            :formatter="this.global.dateFormat"
			            label="创建时间"
		          	></el-table-column>
	        	</el-table>
	      	</template>
      		<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination
		          	@current-change="handleCurrentChangePage"
		          	:current-page="pageNum"
		          	:page-size="limit"
		          	layout="total, prev, pager, next, jumper"
		          	:total="totalPage"
	        	></el-pagination>
      		</div>
    	</div>
    	<!-- 弹框 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" status-icon label-width="120px">
        		<el-form-item label="手机号" prop="mobile">
	          		<el-input type="textarea" :rows="5" v-model="ruleForm.mobile" placeholder="请输入手机号，多个手机号“英文”状态下逗号 “ , ” 隔开" style="width:80%"></el-input>
	        	</el-form-item>
				<el-form-item label="充值亿米数" prop="points">
	          		<el-input v-model="ruleForm.points" placeholder="请输入充值亿米数" style="width:80%"></el-input>
	        	</el-form-item>

      		</el-form>
      		<span slot="footer" class="dialog-footer">
        		<el-button @click="dialogVisible = false">取 消</el-button>
        		<el-button type="primary" @click="onSubmit('ruleForm')">确 定</el-button>
      		</span>
    	</el-dialog>
  	</div>
</template>

<script>
export default {
  	components: {},
  	mounted() {
    	this.init();
  	},
  	data() {
    	return {
      		headers: {
        		xqiao_token: localStorage.getItem("token")
      		},
	      	tableData: [],
	      	pageNum: 1,
	      	limit: 10,
	      	totalPage: 10,
	      	currentRow: "",
	      	mobile:'',
	      	ruleForm: {
		        mobile: "",
	      	},
	      	ruleForms: {
		        mobile: [{ required: false, message: "请输入手机号" }],
		        points: [{ required: true, message: "请输入亿米数" }],
	      	},
	      	dialogVisible: false,
    	};
  	},
  	methods: {
    	//初始化表格数据
    	init() {
      		var params = {
        		pageNum: this.pageNum,
        		limit: this.limit,
        		mobile:this.mobile
      		};
      		this.$get("/userPoints/queryPointsDetail", params)
        	.then(res => {
        		console.log(res)
          		if (res.pageNum > 0) {
            		this.tableData = res.list;
            		this.totalPage = res.total;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
        	.catch(() => {
          		console.log();
        	});
    	},
    	search_mine(){
    		this.init();
    	},
	    //当前页数
	    handleCurrentChangePage(val) {
	      	this.pageNum = val;
	      	this.init();
	    },
    	//弹框关闭按钮
    	handleClose(done) {
	      	if (this.$refs.ruleForm != undefined) {
	        	this.$refs.ruleForm.resetFields();
	      	}
	      	done();
    	},
    	//添加
	    add(row) {
        	this.$refs.multipleTable.setCurrentRow(row);
	      	if (this.$refs["ruleForm"]) {
	        	this.$refs["ruleForm"].resetFields();
	      	}
          	this.currentRow='';
	      	this.dialogVisible = true;
	    },
    	onSubmit(formName) {
	      	this.$refs.ruleForm.validate(valid => {
	          	if (valid) {
	          		var newArr,data;
	          		if(this.ruleForm.mobile){
	            		newArr=this.ruleForm.mobile.split(",");
	            	}
	            	data={mobile:newArr,points:this.ruleForm.points}
	            	this.$post("/userPoints/addPoints", JSON.stringify(data))
	              	.then(res => {
	             		console.log(res)	
             			if(res.code==0){
             				this.$refs.ruleForm.resetFields();
	                  		this.pageNum = 1;
	                  		this.init();
	                  		this.dialogVisible = false;
             				this.$message({
	                    		message: '充值成功',
	                    		type: "success"
	                  		});	
             			}else{
             				this.$alert(res.message, '以下手机号充值失败', {
					          	dangerouslyUseHTMLString: true
					        });
	             		}
	              	})
	          	} else {
	            	console.log("error submit!!");
	            	return false;
	          	}
        	});
    	},
  	}
};
</script>

<style scoped>
.topinput{
	position: relative;
	margin-left: 15px;
	width: 250px
}
.topinput input{
	font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/usersList/userPoints.vue